"use client";

import classNames from "classnames";
import { DEFAULT_ROLE_LABELS, type AppUser } from "../../types";
import {
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownTrigger,
} from "../dropdown";
import { Flex } from "../flex";
import styles from "./HeaderUserDetails.module.scss";

export const HeaderUserDetails = ({
  user,
  onSettings,
  onLogout,
  roleLabels = DEFAULT_ROLE_LABELS,
}: {
  user: AppUser;
  onSettings?: () => void;
  onLogout: () => void | Promise<void>;
  roleLabels?: Record<string, string>;
}) => {
  const displayName =
    [user.firstName, user.lastName].filter(Boolean).join(" ") ||
    user.email?.split("@")[0] ||
    "Account";
  const handle =
    user.username ||
    user.email?.split("@")[0] ||
    (user.accountId ? user.accountId.slice(0, 8) : "user");
  const roleLabel = (user.role && roleLabels[user.role]) || user.role || "—";

  return (
    <Dropdown>
      <DropdownTrigger className={styles["comp__trigger"]}>
        <Flex gap={10} align="center" className={styles["comp"]}>
          <div className={styles["comp__avatar"]} />
          <Flex style={{ paddingRight: 12 }} direction="column">
            <div className={styles["comp__name"]}>{displayName}</div>
            <div className={styles["comp__email"]}>@{handle}</div>
          </Flex>
          <div className={styles["comp__icon"]} aria-hidden>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </Flex>
      </DropdownTrigger>
      <DropdownContent width={280} lockBodyScroll={false}>
        <div className={styles["comp__panel-account"]}>
          <div className={styles["comp__panel-name"]}>{displayName}</div>
          {user.email && (
            <div className={styles["comp__panel-row"]}>
              <span className={styles["comp__panel-label"]}>Email</span>
              <span className={styles["comp__panel-value"]}>{user.email}</span>
            </div>
          )}
          {user.accountId && (
            <div className={styles["comp__panel-row"]}>
              <span className={styles["comp__panel-label"]}>Account</span>
              <span className={styles["comp__panel-value"]}>
                {user.accountId}
              </span>
            </div>
          )}
          <div className={styles["comp__panel-row"]}>
            <span className={styles["comp__panel-label"]}>Role</span>
            <span className={styles["comp__panel-value"]}>{roleLabel}</span>
          </div>
        </div>
        <div className={styles["comp__panel-divider"]} role="separator" />
        {onSettings && (
          <DropdownItem
            id="settings"
            selectable={false}
            className={styles["comp__menu-item"]}
            onClick={onSettings}
          >
            Settings
          </DropdownItem>
        )}
        <DropdownItem
          id="logout"
          selectable={false}
          className={classNames(
            styles["comp__menu-item"],
            styles["comp__menu-item--danger"]
          )}
          onClick={() => {
            void onLogout();
          }}
        >
          Log out
        </DropdownItem>
      </DropdownContent>
    </Dropdown>
  );
};
